export const shade900lighten05 = 'rgba(0, 0, 0, 0.05)'
export const shade900lighten10 = 'rgba(0, 0, 0, 0.1)'
export const shade900lighten20 = 'rgba(0, 0, 0, 0.2)'
export const shade900lighten50 = 'rgba(0, 0, 0, 0.5)'
export const shade900lighten60 = 'rgba(0, 0, 0, 0.6)'
export const shade900lighten80 = 'rgba(0, 0, 0, 0.8)'
